module.exports = __webpack_public_path__ + "static/media/16UNODC29.06d75bc1.jpg";